import React, { useEffect } from "react";
import { BestTable } from "best-common-react";
import { DeleteFormatter, NameFormatter, ModalBody, BigsBestTable } from "./BulkCommon";
import { TitleFormatter, OrgFormatter } from "../../../adminRoster/AdminPersonnelTable";
import { useSelectedPersonnel } from "../../../../contexts/SelectedPersonnelContext";
import styled from "styled-components";
import { PrimaryButtonStyled } from "../../PrimaryButtonStyled";
import { useGlobalModal } from "../../../../contexts/GlobalModalContext";
import { OutlinedButtonStyled } from "../../OutlinedButtonStyled";

const SlateText = styled.div.attrs(() => ({ className: "mt-2 mb-2" }))`
    color: var(--slate);
    font-size: 16px;
`;

const Columns = [
    {
        key: "",
        name: "",
        width: 40,
        formatter: DeleteFormatter,
    },
    {
        key: "lastName",
        name: "Name",
        sortable: true,
        formatter: NameFormatter,
        width: 135,
    },
    {
        key: "title",
        name: "Title",
        sortable: true,
        formatter: TitleFormatter,
        width: 110,
    },
    {
        key: "org",
        name: "Club",
        sortable: true,
        formatter: OrgFormatter,
        width: 75,
    },
    {
        key: "affiliateNameLevel",
        name: "Affiliate",
        sortable: true,
        width: 220,
    },
];

const BulkAcceptAndSendQuestionnaireModalBody: React.FC = () => {
    const {
        initialSelectedPersonnel,
        selectedPersonnel,
        setSelectedPersonnel,
    } = useSelectedPersonnel();

    useEffect(() => {
        return () => {
            setSelectedPersonnel([...initialSelectedPersonnel]);
        };
    }, []);

    return (
        <ModalBody height={300}>
            <SlateText>Accept the following personnel and send them the questionnaire?</SlateText>
            <span
                style={{
                    fontFamily: "Helvetica",
                    fontStyle: "oblique",
                    color: "#92a5ba",
                    fontSize: "0.875rem",
                }}
            >
                {selectedPersonnel.length} personnel selected
            </span>
            <BigsBestTable>
                <BestTable
                    data={selectedPersonnel}
                    columns={Columns}
                    headerHeight={30}
                    maxTableHeight={150}
                    rowHeight={40}
                    rowExpansion={{
                        expandable: false,
                    }}
                />
            </BigsBestTable>
        </ModalBody>
    );
};

type BulkAcceptAndSendQuestionnaireModalFooterProps = {
    personnelAdvancedSearch(arg1: any, arg2: any, arg3: any, arg4: any): void;
    adminSelectedMenuOptions: Array<any>;
    adminAffiliationFilters: Array<any>;
    adminSearchText: Array<any> | string;
};

const BulkAcceptAndSendQuestionnaireModalFooter: React.FC<BulkAcceptAndSendQuestionnaireModalFooterProps> = ({
    personnelAdvancedSearch,
    adminSelectedMenuOptions,
    adminAffiliationFilters,
    adminSearchText,
}) => {
    const { closeModal } = useGlobalModal();
    const {
        selectedPersonnel,
        bulkAcceptAndSendQuestionnairePersonnel,
        bulkActionInFlight,
    } = useSelectedPersonnel();

    return (
        <div className="d-flex">
            <div className="mr-2">
                <PrimaryButtonStyled
                    width={240}
                    height={26}
                    disabled={selectedPersonnel.length === 0 || bulkActionInFlight}
                    onClick={async event => {
                        event.stopPropagation();
                        await bulkAcceptAndSendQuestionnairePersonnel({
                            personnelAdvancedSearch,
                            adminSelectedMenuOptions,
                            adminAffiliationFilters,
                            adminSearchText,
                        });
                    }}
                >
                    {bulkActionInFlight ? "Processing…" : "Accept and Send Questionnaire"}
                </PrimaryButtonStyled>
            </div>

            <OutlinedButtonStyled
                width={80}
                height={26}
                disabled={bulkActionInFlight}
                onClick={event => {
                    event.stopPropagation();
                    closeModal();
                }}
            >
                Cancel
            </OutlinedButtonStyled>
        </div>
    );
};

BulkAcceptAndSendQuestionnaireModalBody.displayName = "BodyContent";
BulkAcceptAndSendQuestionnaireModalFooter.displayName = "FooterContent";

export { BulkAcceptAndSendQuestionnaireModalBody, BulkAcceptAndSendQuestionnaireModalFooter };
